import { DateFormatEnum, formatStringToDate } from "@core/utils";
import { ValidationInputType } from "@generation/core";
import { translate } from "../Locales/translator";
import { AbstractValidation } from "./AbstractValidation";
import { DateValidation } from "./DateValidation";
import { CustomErrorMessage } from "./ValidationHelper";

export class NoFutureDateValidation extends AbstractValidation {
  key = "isNoFutureDate";

  constructor(customErrorMessage?: CustomErrorMessage) {
    super(customErrorMessage);
  }

  validate = (value: ValidationInputType) => {
    if (((value as unknown as string)?.trim() ?? "") == "") {
      return true;
    }

    if (typeof value !== "string") {
      return false;
    }

    const validDate = new DateValidation().validate(value);

    if (!validDate) {
      return false;
    }

    const inputDate = formatStringToDate(value, DateFormatEnum.Date);
    inputDate.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return inputDate <= today;
  };

  defaultMessage = (label: string): string =>
    translate("Generation_Form_{label}IsGeenGeldigeDatumOfInDeToekomst", { label: label});
}
